import { c as _c } from "react/compiler-runtime";
import { HotelSearchSummaryPropertiesType } from "@website/accommodation-ui/hotel-search/hotel-search-summary/hotel-search-summary.types";
import { dateFormat, daysBetweenDates } from "@website/utils/date-format";
import { isFilled } from "@website/utils/is-filled";
import { numberConvert } from "@website/utils/number-convert";
import toNumber from "lodash-es/toNumber";
import { useRouter } from "next/router";
const parseQueryToNumber = (query?: string) => {
  const convertedNumber = toNumber(query);
  return Number.isNaN(convertedNumber) ? 0 : convertedNumber;
};
export const useHotelSearchSummary = properties => {
  const $ = _c(24);
  const router = useRouter();
  const {
    searchType,
    cityTitle,
    dateFrom,
    dateTo,
    adults,
    children,
    noRooms
  } = properties;
  let t0;
  if ($[0] !== dateFrom || $[1] !== router.locale) {
    t0 = dateFormat(dateFrom, {
      locale: router.locale,
      template: "dd MMMM"
    });
    $[0] = dateFrom;
    $[1] = router.locale;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = t0 as string;
  let t2;
  if ($[3] !== dateTo || $[4] !== router.locale) {
    t2 = dateFormat(dateTo, {
      locale: router.locale,
      template: "dd MMMM"
    });
    $[3] = dateTo;
    $[4] = router.locale;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = t2 as string;
  let t4;
  if ($[6] !== adults || $[7] !== children || $[8] !== router.locale) {
    t4 = !isFilled(adults) && !isFilled(children) ? undefined : numberConvert(parseQueryToNumber(adults) + parseQueryToNumber(children), {
      locale: router.locale
    });
    $[6] = adults;
    $[7] = children;
    $[8] = router.locale;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== noRooms || $[11] !== router.locale) {
    t5 = isFilled(noRooms) ? numberConvert(parseQueryToNumber(noRooms), {
      locale: router.locale
    }) : undefined;
    $[10] = noRooms;
    $[11] = router.locale;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== dateFrom || $[14] !== dateTo) {
    t6 = daysBetweenDates(dateFrom, dateTo);
    $[13] = dateFrom;
    $[14] = dateTo;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== cityTitle || $[17] !== searchType || $[18] !== t1 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6) {
    t7 = {
      searchType,
      cityTitle,
      dateFrom: t1,
      dateTo: t3,
      passengersCount: t4,
      roomsCount: t5,
      nightCount: t6
    };
    $[16] = cityTitle;
    $[17] = searchType;
    $[18] = t1;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
};